import { ValueOf } from '@xhgj/xh-jsutils'
import { customCreateEnum } from './enumArray'

/**
 * 待我审核
 * AI审核建议
 */
const normalAiAuditSuggestionList = [
  {
    label: '通过',
    value: 'PASS',
  },
  {
    label: '驳回',
    value: 'REJECT',
  },
  {
    label: '人工审核',
    value: 'MANUAL',
  },
  {
    label: 'AI审核中',
    value: 'REVIEW',
  },
  {
    label: '空',
    value: 'EMPTY',
  },
] as const

export type NormalAiAuditSuggestionValue = ValueOf<
  typeof normalAiAuditSuggestionList
>
export const normalAiAuditSuggestionListEnum = customCreateEnum(
  normalAiAuditSuggestionList,
)

const aiAuditItemTypeList = [
  {
    label: '资质审核',
    value: 'QUALIFICATION',
  },
  {
    label: '类目审核',
    value: 'CATEGORY',
  },
  {
    label: '文本审核',
    value: 'TEXT',
  },
  {
    label: '图片审核',
    value: 'IMAGE',
  },
  {
    label: '图文一致性审核',
    value: 'CONSISTENCY',
  },
]
export const aiAuditItemTypeListEnum = customCreateEnum(aiAuditItemTypeList)
export type AiAuditItemTypeValue = ValueOf<typeof aiAuditItemTypeListEnum>
import { ValueOf } from '@xhgj/xh-jsutils'
import { customCreateEnum } from './enumArray'

/**
 * 待我审核
 * AI审核建议
 */
const normalAiAuditSuggestionList = [
  {
    label: '通过',
    value: 'PASS',
  },
  {
    label: '驳回',
    value: 'REJECT',
  },
  {
    label: '人工审核',
    value: 'MANUAL',
  },
  {
    label: 'AI审核中',
    value: 'REVIEW',
  },
  {
    label: '空',
    value: 'EMPTY',
  },
] as const

export type NormalAiAuditSuggestionValue = ValueOf<
  typeof normalAiAuditSuggestionList
>
export const normalAiAuditSuggestionListEnum = customCreateEnum(
  normalAiAuditSuggestionList,
)

const aiAuditItemTypeList = [
  {
    label: '资质审核',
    value: 'QUALIFICATION',
  },
  {
    label: '类目审核',
    value: 'CATEGORY',
  },
  {
    label: '文本审核',
    value: 'TEXT',
  },
  {
    label: '图片审核',
    value: 'IMAGE',
  },
  {
    label: '图文一致性审核',
    value: 'CONSISTENCY',
  },
]
export const aiAuditItemTypeListEnum = customCreateEnum(aiAuditItemTypeList)
export type AiAuditItemTypeValue = ValueOf<typeof aiAuditItemTypeListEnum>
